<div *ngIf="isQuickThemeSelectEnabled" id="kt_theme_selection_panel_toggle" class="topbar-item">
    <div [class]="customStyle">
        <i class="flaticon-interface-7"></i>
    </div>
</div>